module.exports = __webpack_public_path__ + "static/media/founder.3f7e8276.png";